import Backbone from 'backbone';
import Category from './Category';

export default Backbone.Collection.extend({
  model: Category
});



// WEBPACK FOOTER //
// webpack://grapesjs/src/block_manager/model/Categories.js